import { animate, useDragControls, useMotionValue } from 'motion-v';

const PADDING = 16;

const getCorners = () => {
  if (!import.meta.client) {
    return [{ x: PADDING, y: 600 - PADDING }];
  }
  return [
    { x: PADDING, y: PADDING },
    { x: window.innerWidth - PADDING, y: PADDING },
    { x: PADDING, y: window.innerHeight - PADDING },
    { x: window.innerWidth - PADDING, y: window.innerHeight - PADDING },
  ];
};

const nearestCorner = (cx: number, cy: number) =>
  getCorners().reduce((best, corner) => {
    const d = Math.hypot(corner.x - cx, corner.y - cy);
    const bd = Math.hypot(best.x - cx, best.y - cy);
    return d < bd ? corner : best;
  });

export const useDevPanelDrag = () => {
  const defaultY = import.meta.client ? window.innerHeight - PADDING : 600 - PADDING;

  const x = useMotionValue(PADDING);
  const y = useMotionValue(defaultY);

  const isDragging = ref(false);
  const hasDragged = ref(false);
  const isTopCorner = ref(false);
  const isRightCorner = ref(false);

  const dragControls = useDragControls();

  const updateCornerState = (cx: number, cy: number) => {
    if (!import.meta.client) {
      return;
    }
    isTopCorner.value = cy < window.innerHeight / 2;
    isRightCorner.value = cx > window.innerWidth / 2;
  };

  onMounted(() => updateCornerState(x.get(), y.get()));

  const onDragStart = (event: PointerEvent) => {
    hasDragged.value = false;
    dragControls.start(event);
  };

  const onDrag = () => {
    isDragging.value = true;
    hasDragged.value = true;
    updateCornerState(x.get(), y.get());
  };

  const onDragEnd = () => {
    isDragging.value = false;
    const corner = nearestCorner(x.get(), y.get());
    animate(x, corner.x, { type: 'spring', stiffness: 400, damping: 30 });
    animate(y, corner.y, { type: 'spring', stiffness: 400, damping: 30 });
    updateCornerState(corner.x, corner.y);
  };

  return { x, y, dragControls, isDragging, hasDragged, isTopCorner, isRightCorner, onDragStart, onDrag, onDragEnd };
};
